import React from 'react';
import { teachingSituations } from '../data/content';
export function TeachingSituations() {
  return <section className="bg-white px-4 py-6 md:px-12 md:py-8" data-id="element-182" data-mp="1eeie4uamy551">
      <h2 className="mx-auto max-w-[600px] text-center font-heading text-[22px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[30px]" data-id="element-183" data-mp="1s53x0j03af2x">
        Made for real aqua fitness teaching situations.
      </h2>
      <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-184" data-mp="222iemlxr19wt">
        {teachingSituations.map(s => <li key={s.title} className="grid gap-1 py-3 md:grid-cols-[240px_1fr] md:gap-6" data-id="element-185" data-mp="1x35ifakzmqhk">
            <h3 className="font-heading text-[14px] font-extrabold uppercase leading-tight text-brand md:text-[15px]" data-id="element-186" data-mp="2b2ye7kbdfwwe">
              {s.title}
            </h3>
            <p className="text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-187" data-mp="gpytjcs4wci9">{s.text}</p>
          </li>)}
      </ul>
      <p className="mt-3.5 text-center font-heading text-[13px] font-extrabold uppercase leading-tight text-goldDark md:text-[15px]" data-id="element-188" data-mp="covayiipc2dc">
        Less time building workout plans. More time leading your classes.
      </p>
    </section>;
}